export interface CardConfig {
    id: string;
    type: string;
    role?: string;
    transitions?: { label: string; target: string; type?: string }[];
    props?: Record<string, any>;
}

export async function loadDeck(deckId: string, isInitial: boolean = false): Promise<CardConfig[] | null> {
    try {
        const response = await fetch(`/data/${deckId}.json`);
        if (!response.ok) {
            console.error(`Failed to load deck: ${deckId}`);
            return null;
        }
        const rawCards = await response.json() as CardConfig[];
        let newCards = rawCards;

        // If it's a connected deck (not the initial matching URL), namespace the IDs
        if (!isInitial) {
            newCards = rawCards.map(card => ({
                ...card,
                id: `${deckId}-${card.id}`,
                role: undefined, // Clear role for connected decks
                transitions: card.transitions?.map(t => {
                    // Only prefix target if it's NOT a 'connect' type
                    if (t.type !== 'connect') {
                        return { ...t, target: `${deckId}-${t.target}` };
                    }
                    return t;
                })
            }));
        }

        return newCards;
    } catch (e) {
        console.error(`Error loading deck ${deckId}:`, e);
        return null;
    }
}
